import React, { useEffect, useState } from 'react'
import $ from 'jquery';
import 'datatables.net-dt/js/dataTables.dataTables.js';
import { Icon } from '@iconify/react/dist/iconify.js';
import { Link } from 'react-router-dom';
import toast from 'react-hot-toast';
import { deleteCategoryApi, deleteEmailTemplate, deletePackageApi, deleteShippingApi, getCategoriesApi, getEmailTemplate, getPackageEnquiryApi, getPackageSizeApi, getShippingChargeApi, getUmbrellaDataApi, sendMailUserApi, sendUmbrellaMailApi, updateUmbrellaStatusApi } from '../../apiHelper/authService';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { setSelectedCategory, setSelectedEmailTemplate, setSelectedFollowUp, setSelectedPackage, setSelectedShippingCharge } from '../../redux/authModalSlice';
const UmbrellaTableV2 = () => {
    const [activeTab, setActiveTab] = useState("SHIPPED");
    const tabOptions = [
        { label: "SHIPPED", value: "SHIPPED" },
        { label: "REACHED TO LOCAL PARTNER", value: "REACHED_TO_LOCAL_PARTNER" },

    ];
    const [sendEmailTemplateForm, setSendEmailTemplateForm] = useState({ subject: "", email_template_id: "", message: "" });
    const [selectedContainerId, setSelectedContainerId] = useState("")
    const [sendingEmail, setSendingEmail] = useState(false)
    const [emailTemplates, setEmailTemplates] = useState([]);
    const [umbrellaLoading,setUmbrellaLoading] = useState(false)

    const getEmailTemplates = async () => {
        setLoading(true);



        // const toastId = toast.loading("Fetching Email Templates...");

        try {
            const data = await getEmailTemplate();
            // setCategories(data);
            setEmailTemplates(data?.emailTemplates)
            // toast.success("Email Templates fetched successfully!", { id: toastId });
        } catch (err) {
            console.error("Fetch Error:", err);

            // toast.error(
            //     err?.message || "Something went wrong while fetching email templates.",
            //     { id: toastId }
            // );
        } finally {
            setLoading(false);
        }
    };


    useEffect(() => {

        getEmailTemplates()


    }, [])
    const stripHtmlTags = (html) => {
        const div = document.createElement("div");
        div.innerHTML = html;
        return div.textContent || div.innerText || "";
    };


    const selectedTemplate = emailTemplates?.find(
        (template) => template.id === sendEmailTemplateForm.email_template_id
    );

    const handleSendMail = async (payload = {}) => {
        setSendingEmail(true);

        try {
            await sendUmbrellaMailApi({ ...payload, containerId: selectedContainerId, subject: selectedTemplate?.subject, message: selectedTemplate?.message });

            // setActiveStatus(status); 
            toast.success("Mail has been send.")
        } catch (err) {
            // console.error("Error:", err);
            toast.error(err)
        } finally {
            setSendingEmail(false);
        }
    };


    const [currentPage, setCurrentPage] = useState(1);
    const [selectedShippingId, setSelectedShippingId] = useState(null);
    const navigate = useNavigate()

    const dispatch = useDispatch()


    const [itemsPerPage] = useState(10);


    const { user } = useSelector((state) => state.authModal);
    // const [categories, setCategories] = useState();
    // const [shippingCharges, setShippingCharges] = useState();
    const [enquiryData, setEnquiryData] = useState()



    const fromCountry = user?.from;
    const toCountry = user?.to;




    // console.log("UserData:", fromCountry)

    const [loading, setLoading] = useState(false);
    // useEffect(() => {
    //     const table = $('#dataTable').DataTable({
    //         pageLength: 10,
    //     });
    //     return () => {
    //         table.destroy(true);
    //     };
    // }, []);




    const getPackageEnquiry = async () => {
        setLoading(true);
        setUmbrellaLoading(true);


        // const toastId = toast.loading("Fetching Email Templates...");

        try {
            const data = await getUmbrellaDataApi();
            // setCategories(data);
            // setShippingCharges(data)
            setEnquiryData(data)
        setUmbrellaLoading(false);

            // toast.success("Email Templates fetched successfully!", { id: toastId });
        } catch (err) {
            console.error("Fetch Error:", err);

            // toast.error(
            //     err?.message || "Something went wrong while fetching email templates.",
            //     { id: toastId }
            // );
        } finally {
            setLoading(false);
        setUmbrellaLoading(false);

        }
    };


    useEffect(() => {

        getPackageEnquiry()


    }, [])

    console.log(enquiryData)



    const [searchQuery, setSearchQuery] = useState("");




    const filteredEnquiries = enquiryData?.filter(
        (item) => item?.order_status === activeTab
    );

    const filteredData = filteredEnquiries?.filter((item) =>
        Object.values(item).some((val) =>
            String(val).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );


    const totalItems = filteredData?.length || 0;
    const itemsPerPageSafe = itemsPerPage || 1;
    const totalPages = Math.ceil(totalItems / itemsPerPageSafe);
    const startIdx = (currentPage - 1) * itemsPerPage;
    // const currentItems = enquiryData?.slice(startIdx, startIdx + itemsPerPage);
    const currentItems = Array.isArray(filteredData)
        ? filteredData.slice(startIdx, startIdx + itemsPerPage)
        : [];


    const goToPage = (page) => {
        if (page >= 1 && page <= totalPages) {
            setCurrentPage(page);
        }
    };

    const handleConfirmDelete = async () => {
        if (!selectedShippingId) return;

        setLoading(true);



        const toastId = toast.loading("Deleting...");

        try {
            const data = await deleteShippingApi(selectedShippingId);
            // getPackageSizes()
            // getShipCharges()

            toast.success("Delted", { id: toastId });
            const modalEl = document.getElementById('exampleModalEdit');
            const modalBackdrop = document.querySelector('.modal-backdrop');

            modalEl.classList.remove('show');
            modalEl.style.display = 'none';
            modalEl.setAttribute('aria-hidden', 'true');

            if (modalBackdrop) modalBackdrop.remove();
            document.body.classList.remove('modal-open');
            document.body.style.overflow = '';
            document.body.style.paddingRight = '';
        } catch (err) {
            console.error("Fetch Error:", err);

            toast.error(
                err?.message || "Something went wrong while fetching categories.",
                { id: toastId }
            );
        } finally {
            setLoading(false);
            // setSelectedCategoryId(null)
        }

    }

    // function stripHtml(html) {
    //     const div = document.createElement('div');
    //     div.innerHTML = html;
    //     return div.textContent || div.innerText || '';
    // }

    // const handleConfirmDelete = async () => {
    //     if (!selectedMailId) return;

    //     setLoading(true);



    //     const toastId = toast.loading("Deleting...");

    //     try {
    //         const data = await deleteEmailTemplate({ id: selectedMailId });
    //         getEmailTemplates()


    //         toast.success("Delted", { id: toastId });
    //         const modalEl = document.getElementById('exampleModalEdit');
    //         const modalBackdrop = document.querySelector('.modal-backdrop');

    //         modalEl.classList.remove('show');
    //         modalEl.style.display = 'none';
    //         modalEl.setAttribute('aria-hidden', 'true');

    //         if (modalBackdrop) modalBackdrop.remove();
    //         document.body.classList.remove('modal-open');
    //         document.body.style.overflow = '';
    //         document.body.style.paddingRight = '';
    //     } catch (err) {
    //         console.error("Fetch Error:", err);

    //         toast.error(
    //             err?.message || "Something went wrong while fetching categories.",
    //             { id: toastId }
    //         );
    //     } finally {
    //         setLoading(false);

    //     }

    // }

    function getTotalVal(taxPercent, internationCharge, localCharge, humanCharge) {
        const subtotal = internationCharge + localCharge + humanCharge;
        const taxAmount = (subtotal * taxPercent) / 100;
        const total = subtotal + taxAmount;
        return total.toFixed(2);
    }

    function formatDate(dateString) {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    }



    const handleStatusChange = async (selectedStatus, orderId) => {
        setLoading(true);



        const toastId = toast.loading("Updating Status...");

        try {
            const data = await updateUmbrellaStatusApi({ orderStatus: selectedStatus, containerId: orderId });
            // setCategories(data);
            // setShippingCharges(data)
            // setEnquiryData(data)
            getPackageEnquiry()

            toast.success("Status Updated", { id: toastId });
        } catch (err) {
            console.error("Fetch Error:", err);

            toast.error(
                err?.message || "Something went wrong ",
                { id: toastId }
            );
        } finally {
            setLoading(false);
        }
    };


    return (
      <>
        {/* <div className="col-xxl-12 mb-16">
                <div className="card p-0 overflow-hidden position-relative radius-12 h-100">

                    <div className="card-body px-14">
                        <ul
                            className="nav bordered-tab border border-top-0 border-start-0 border-end-0 d-inline-flex nav-pills mb-8 w-100"
                            role="tablist"
                        >
                            {tabOptions.map((tab) => (
                                <li className="nav-item" key={tab.value} role="presentation">
                                    <button
                                        className={`nav-link px-16 py-10 ${activeTab === tab.value ? "active" : ""}`}
                                        type="button"
                                        role="tab"
                                        onClick={() => setActiveTab(tab.value)}
                                    >
                                        {tab.label}
                                    </button>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div> */}
        <div className="card basic-data-table">
          {/* <div className="card-header d-flex flex-row justify-content-between align-items-center">
                    <h5 className="card-title mb-0">Umbrella Management</h5>

                    <div className='d-flex flex-row gap-3 align-items-center'>


                        <div className="icon-field">
                            <input
                                type="text"
                                name="search"
                                className="form-control form-control-sm w-auto rounded-3"
                                placeholder="Search"
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                            />
                            <span className="icon">
                                <Icon icon="ion:search-outline" />
                            </span>
                        </div>


                        <Link to={"/add-umbrella"}>
                            <button
                                type="button"
                                className="btn btn-primary radius-8 px-20 py-11 d-flex align-items-center gap-2"
                            >
                                Add New Umbrella
                                <Icon
                                    icon="mingcute:add-line"
                                    className="text-xl"
                                />
                            </button></Link>



                    </div>


                </div> */}

          <div className="card-header border-bottom bg-base py-16 px-24 d-flex align-items-center flex-wrap gap-3 justify-content-between">
            <div className="d-flex align-items-center flex-wrap gap-3">
              <form className="navbar-search">
                <input
                  type="text"
                  className="bg-base h-40-px w-auto"
                  name="search"
                  placeholder="Search"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                />
                <Icon icon="ion:search-outline" className="icon" />
              </form>
            </div>

            <div style={{ display: "flex", gap: "15px", alignItems: "center" }}>
              <div className="position-relative" style={{ minWidth: "180px" }}>
                <Icon
                  icon="solar:alt-arrow-down-outline"
                  className="position-absolute"
                  style={{
                    right: "12px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    pointerEvents: "none",
                    color: "#6c757d",
                    zIndex: 1,
                  }}
                />

                <select
                  className="custom-select-no-arrow form-select form-select-sm pe-5 ps-3 rounded border"
                  style={{
                    height: "40px",
                    display: "flex",
                    alignItems: "center",
                  }}
                  value={activeTab}
                  onChange={(e) => setActiveTab(e.target.value)}
                >
                  {tabOptions.map((tab) => (
                    <option key={tab.value} value={tab.value}>
                      {tab.label}
                    </option>
                  ))}
                </select>
              </div>

              <Link
                to={"/add-umbrella"}
                className="btn btn-primary text-sm btn-sm px-12 py-12 radius-8 d-flex align-items-center gap-2"
              >
                <Icon
                  icon="ic:baseline-plus"
                  className="icon text-xl line-height-1"
                />
                Add New Umbrella
              </Link>
            </div>
          </div>

          <div className="card-body">
            <div className="table-responsive" style={{ minHeight: "50vh" }}>
              <table className="table vertical-striped-table mb-0">
                <thead>
                  <tr>
                    <th scope="col">Container Identifier</th>
                    <th scope="col"> Shipment Type</th>
                    {/* <th scope="col">		Human Resource Charge</th> */}
                    <th scope="col"> No. of Orders</th>

                    <th scope="col"> Created Date</th>
                    <th scope="col"> Expected Date</th>
                    <th scope="col"> Email</th>
                    {activeTab !== "REACHED_TO_LOCAL_PARTNER" && (
                      <th scope="col"> Status</th>
                    )}
                  </tr>
                </thead>
                <tbody>
                  {umbrellaLoading ? (
                    <tr>
                      <td colSpan="10" className="text-center py-20">
                        <div
                          className="spinner-border"
                          role="status"
                          style={{
                            color: "#243E85",
                            width: "2rem",
                            height: "2rem",
                            borderWidth: "0.3em",
                          }}
                        >
                          <span className="visually-hidden">Loading...</span>
                        </div>
                      </td>
                    </tr>
                  ) : currentItems?.length > 0 ? (
                    currentItems?.map((umbrellaData) => (
                      <tr key={umbrellaData.id}>
                        <td>
                          <div className="d-flex align-items-center">
                            <h6 className="text-md mb-0 fw-medium flex-grow-1 ">
                              {umbrellaData.identifier_id}
                            </h6>
                          </div>
                        </td>
                        {/* 

                                            <td>
                                                <span
                                                    className={`${umbrellaData?.shipment_type === "AIR"
                                                        ? "bg-success-focus text-success-main"
                                                        : "bg-warning-focus text-warning-main"
                                                        } px-24 py-4 rounded-pill fw-medium text-sm`}
                                                >
                                                   
                                                    {umbrellaData?.shipment_type}
                                                </span>
                                            </td> */}

                        <td>
                          <span
                            style={{ width: "70%", margin: "auto" }}
                            className={`${
                              umbrellaData?.shipment_type === "AIR"
                                ? "bg-success-focus text-success-main"
                                : "bg-warning-focus text-warning-main"
                            } px-24 py-4 rounded-pill fw-medium text-sm d-flex align-items-center gap-2 justify-content-center`}
                          >
                            {umbrellaData?.shipment_type === "AIR" ? (
                              <>
                                <Icon 
                                style={{flexShrink:"0"}}
                                  icon="mdi:airplane"
                                  width="16"
                                  height="16"
                                />
                                Air
                              </>
                            ) : (
                              <>
                                <Icon 
                                style={{flexShrink:"0"}}
                                
                                icon="mdi:ferry" width="16" height="16" />
                                Ship
                              </>
                            )}
                          </span>
                        </td>

                        <td>
                          <div className="d-flex align-items-center">
                            <h6 className="text-md mb-0 fw-medium flex-grow-1 ">
                              {umbrellaData?._count?.shipment_orders}
                            </h6>
                          </div>
                        </td>

                        <td>
                          <div className="d-flex align-items-center">
                            <h6 className="text-md mb-0 fw-medium flex-grow-1">
                              {formatDate(umbrellaData?.createdAt)}
                            </h6>
                          </div>
                        </td>

                        <td>
                          <div className="d-flex align-items-center">
                            <h6 className="text-md mb-0 fw-medium flex-grow-1">
                              {formatDate(umbrellaData?.expected_date)}
                            </h6>
                          </div>
                        </td>

                        <td>
                          <div
                            className="d-flex align-items-center"
                            style={{ justifyContent: "start" }}
                          >
                            <span
                              onClick={() =>
                                setSelectedContainerId(umbrellaData?.id)
                              }
                              data-bs-toggle="modal"
                              data-bs-target="#sendMail"
                              className="w-32-px h-32-px cursor-pointer me-8 bg-danger-focus text-danger-main rounded-circle d-inline-flex align-items-center justify-content-center"
                              title="Send Email"
                            >
                              <Icon icon="lucide:mail" />
                            </span>
                          </div>
                        </td>

                        {activeTab !== "REACHED_TO_LOCAL_PARTNER" && (
                          <td>
                            <div className="dropdown d-flex justify-content-start">
                              <button
                                className="btn bg-success-100 border-success-100 text-success-600 px-18 py-11 d-flex align-items-center justify-content-center rounded-circle"
                                type="button"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                                title="Update Status"
                              >
                                <Icon icon="lucide:refresh-ccw" />
                              </button>

                              <ul className="dropdown-menu">
                                {tabOptions
                                  .filter((option) => {
                                    // Show all options if current status is HOLD or CANCELLED

                                    // Otherwise only show statuses *after* current status (forward progression)
                                    const currentIndex = tabOptions.findIndex(
                                      (opt) =>
                                        opt.value === umbrellaData?.order_status
                                    );
                                    const optionIndex = tabOptions.findIndex(
                                      (opt) => opt.value === option.value
                                    );

                                    // optionIndex must be greater than currentIndex to exclude current and previous statuses
                                    return optionIndex > currentIndex;
                                  })
                                  .map((option) => (
                                    <li key={option.value}>
                                      <Link
                                        className="dropdown-item px-16 py-8 rounded text-secondary-light bg-hover-neutral-200 text-hover-neutral-900"
                                        onClick={() =>
                                          handleStatusChange(
                                            option.value,
                                            umbrellaData?.id
                                          )
                                        }
                                      >
                                        {option.label}
                                      </Link>
                                    </li>
                                  ))}
                              </ul>
                            </div>
                          </td>
                        )}
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="9" className="text-center py-16 text-muted">
                        No Container found.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            {filteredData?.length > itemsPerPage && (
              <div className="d-flex flex-wrap align-items-center justify-content-between gap-2 mt-24">
                <span>
                  Showing {startIdx + 1} to{" "}
                  {Math.min(startIdx + itemsPerPage, filteredData?.length)} of{" "}
                  {filteredData?.length} entries
                </span>
                <ul className="pagination d-flex flex-wrap align-items-center gap-2 justify-content-center">
                  <li className="page-item">
                    <button
                      className="page-link text-secondary-light fw-medium radius-4 border-0 px-10 py-10 d-flex align-items-center justify-content-center h-32-px me-8 w-32-px bg-base"
                      onClick={() => goToPage(currentPage - 1)}
                      disabled={currentPage === 1}
                    >
                      <Icon icon="ep:d-arrow-left" className="text-xl" />
                    </button>
                  </li>

                  {[...Array(totalPages)].map((_, index) => (
                    <li className="page-item" key={index}>
                      <button
                        className={`page-link ${
                          currentPage === index + 1
                            ? "bg-primary-600 text-white"
                            : "bg-primary-50 text-secondary-light"
                        } fw-medium radius-4 border-0 px-10 py-10 d-flex align-items-center justify-content-center h-32-px me-8 w-32-px`}
                        onClick={() => goToPage(index + 1)}
                      >
                        {index + 1}
                      </button>
                    </li>
                  ))}

                  <li className="page-item">
                    <button
                      className="page-link text-secondary-light fw-medium radius-4 border-0 px-10 py-10 d-flex align-items-center justify-content-center h-32-px me-8 w-32-px bg-base"
                      onClick={() => goToPage(currentPage + 1)}
                      disabled={currentPage === totalPages}
                    >
                      <Icon icon="ep:d-arrow-right" className="text-xl" />
                    </button>
                  </li>
                </ul>
              </div>
            )}
          </div>
        </div>

        <div
          className="modal fade"
          id="exampleModalEdit"
          tabIndex={-1}
          aria-labelledby="exampleModalEditLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content radius-16 bg-base">
              <div className="modal-header py-16 px-24 border border-top-0 border-start-0 border-end-0">
                <h1 className="modal-title fs-5" id="exampleModalEditLabel">
                  Confirm Deletion
                </h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                />
              </div>
              <div className="modal-body p-24 text-center">
                <p className="mb-4 fs-6 text-secondary">
                  Are you sure you want to delete this item?
                </p>
                <div className="d-flex justify-content-center gap-3 mt-3">
                  <button
                    type="button"
                    className="btn btn-danger"
                    onClick={handleConfirmDelete}
                  >
                    Confirm
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className="modal fade"
          id="sendMail"
          tabIndex={-1}
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-lg modal-dialog modal-dialog-centered">
            <div className="modal-content radius-16 bg-base">
              <div className="modal-header py-16 px-24 border border-top-0 border-start-0 border-end-0">
                <h1 className="modal-title fs-5" id="exampleModalLabel">
                  Send mail
                </h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                />
              </div>
              <div className="modal-body p-24">
                <form
                  onSubmit={async (e) => {
                    e.preventDefault();

                    // Optional validation

                    await handleSendMail({
                      email_template_id:
                        sendEmailTemplateForm?.email_template_id,
                    });

                    setSendEmailTemplateForm({
                      message: "",
                      subject: "",
                      email_template_id: "",
                    });

                    const modalEl = document.getElementById("sendMail");
                    const modalBackdrop =
                      document.querySelector(".modal-backdrop");

                    modalEl.classList.remove("show");
                    modalEl.style.display = "none";
                    modalEl.setAttribute("aria-hidden", "true");

                    if (modalBackdrop) modalBackdrop.remove();
                    document.body.classList.remove("modal-open");
                    document.body.style.overflow = "";
                    document.body.style.paddingRight = "";
                  }}
                >
                  <div className="row">
                    {/* Remarks Field */}

                    <div className="col-12 col-md-12 mb-20">
                      <label className="form-label fw-semibold text-primary-light text-sm mb-8">
                        Select Email Template
                      </label>
                      <select
                        required
                        className="form-control radius-8"
                        value={sendEmailTemplateForm.email_template_id}
                        onChange={(e) =>
                          setSendEmailTemplateForm({
                            ...sendEmailTemplateForm,
                            email_template_id: e.target.value,
                          })
                        }
                      >
                        <option value="">-- Select Email Template --</option>
                        {emailTemplates?.map((template) => (
                          <option key={template.id} value={template.id}>
                            {template.title}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="col-12 col-md-12 mb-20">
                      <label className="form-label fw-semibold text-primary-light text-sm mb-8">
                        Subject
                      </label>
                      <input
                        required
                        className="form-control radius-8"
                        placeholder="subject"
                        value={selectedTemplate?.subject}
                        disabled
                      />
                    </div>

                    <div className="col-12 col-md-12 mb-20">
                      <label className="form-label fw-semibold text-primary-light text-sm mb-8">
                        Message
                      </label>
                      <textarea
                        required
                        className="form-control radius-8"
                        placeholder="message"
                        value={
                          selectedTemplate
                            ? stripHtmlTags(selectedTemplate.message)
                            : ""
                        }
                        disabled
                        rows={3}
                      />
                    </div>

                    {/* Email Template Select */}

                    {/* Submit Button */}
                    <div className="d-flex align-items-center justify-content-start gap-3 mt-12">
                      <button
                        disabled={sendingEmail}
                        type="submit"
                        className="btn btn-primary border border-primary-600 text-md px-48 py-12 radius-8"
                      >
                        {sendingEmail ? "Sending..." : "Send"}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </>
    );
}

export default UmbrellaTableV2